import React, { FC } from 'react';

import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Private } from '#/containers/router/routes/Private';

interface NonPaymentsProps extends SectionProps {}

export const NonPayments: FC<NonPaymentsProps> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();
  return (
    <Can hasRoles={['zazume', 'admin', 'buildingManager']}>
      <NavigationLink
        to={Private.NON_PAYMENTS.route}
        icon="gravel"
        title={t('nonPayment.title')}
        onClick={onClickItem}
        depth={depth}
        isMobile={isMobile}
      />
    </Can>
  );
};
